import styled from 'styled-components';
import { Text } from '@lmn/design-system';
import { safeGap } from '../../../../styles/mixins';
import { primaryButton } from '../../../../styles/buttons';

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
  ${safeGap('16px')};
`;

export const ModalPrimaryButton = styled.button`
  ${primaryButton};
  flex-grow: 1;
`;

export const ModalImage = styled.img`
  width: 88px;
  height: 88px;
  margin-bottom: 16px;
`;

export const ModalTitle = styled(Text).attrs({ variant: 'Title4' })`
  margin-bottom: 8px;
`;

export const ModalBody = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
